import React from 'react';
import { styled } from 'linaria/react';
import { Title } from './Title';
import Main3D from '../3D/Main3D';

const SofaConfiguratorWrapper = styled('div')`
  width: 100%;
  height: 100%;
`;

export const SofaConfigurator = ({ title, foreground }) => {
  return (
    <SofaConfiguratorWrapper>
      <Title title={title} foreground={foreground} />
      <Main3D />
    </SofaConfiguratorWrapper>
  );
};
